<template lang="pug">

  form-group-row(:form="form" :label="label" name="password" :required="required")
    form-input(:form="form" name="password" type="password")

</template>

<script>

export default {
  name: 'user-input-password',

  props: {
    label: {
      type: String,
      default: 'Password',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    form: null,
  }),

  watch: {
    'form.password'(newVal) {
      if (newVal === '') {
        this.$set(this.form, 'password', null)
      }
    },
  },

  async created() {
    this.form = this.$parent.form;
    this.form.password = null;
  },
}

</script>
